import React, { useState } from "react";
import axios from "axios";
import { base_url } from "../General/Notification";
import { notifyError } from "../General/Notification";
import "./BatchExportButton.css";

/**
 * BE-6 — Batch Export Button
 * Lets user select multiple reports and export them as a ZIP of Excel files.
 *
 * Props:
 *   availableReports — array of { key, label } for the checkbox list
 *   translate        — i18n function
 */
function BatchExportButton({ availableReports, translate }) {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  const toggle = (key) => {
    setSelected((prev) =>
      prev.includes(key) ? prev.filter((k) => k !== key) : [...prev, key]
    );
  };

  const selectAll = () => {
    if (selected.length === availableReports.length) {
      setSelected([]);
    } else {
      setSelected(availableReports.map((r) => r.key));
    }
  };

  const handleExport = () => {
    if (selected.length === 0) return;
    setLoading(true);
    const token = localStorage.getItem("tokenMiamed");
    axios
      .post(
        `${base_url}api/batch-export`,
        { reports: selected },
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob",
        }
      )
      .then((res) => {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `reports-batch-${Date.now()}.zip`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        setOpen(false);
        setSelected([]);
      })
      .catch(() => {
        notifyError(true, translate("batch_export_error"));
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="batch-export-wrapper">
      <button
        className="batch-export-trigger"
        onClick={() => setOpen((p) => !p)}
        title={translate("batch_export_title")}
      >
        <span className="las la-file-archive"></span>
        {translate("batch_export_btn")}
      </button>

      {open && (
        <div className="batch-export-dropdown">
          <div className="batch-export-header">
            <span>{translate("batch_export_select")}</span>
            <button className="batch-export-select-all" onClick={selectAll}>
              {selected.length === availableReports.length
                ? translate("batch_export_deselect_all")
                : translate("batch_export_select_all")}
            </button>
          </div>
          <div className="batch-export-list">
            {availableReports.map((r) => (
              <label key={r.key} className="batch-export-item">
                <input
                  type="checkbox"
                  checked={selected.includes(r.key)}
                  onChange={() => toggle(r.key)}
                />
                <span>{r.label}</span>
              </label>
            ))}
          </div>
          <button
            className="batch-export-go"
            disabled={selected.length === 0 || loading}
            onClick={handleExport}
          >
            {loading ? (
              <span className="las la-spinner la-spin"></span>
            ) : (
              <span className="las la-download"></span>
            )}
            {translate("batch_export_download")}
          </button>
        </div>
      )}
    </div>
  );
}

export default BatchExportButton;
